import styled from 'styled-components'

import { theme } from 'lib/styleUtils'

const Label = styled.p`
  font-size: ${theme('fonts.sizes.s')};
  font-weight: ${theme('fonts.weights.bold')};
  width: 130px;
`

export default Label
